import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-sites',
  templateUrl: './help-sites.component.html',
  styleUrls: ['./help-sites.component.scss']
})
export class HelpSitesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
